<span
  *ngFor="let option of store_info.cartCustomOptions; trackBy: trackTimestamp"
>
  <div
    *ngIf="
      store_info.cartCustomOptionsActive &&
      cart.length > 0 &&
      option.active &&
      ((option.preNameId !== 'partial_payment' && !option.only_kiosk) ||
        (option.preNameId === 'partial_payment' &&
          option.upos_active === true && uposMoUser)) &&
      ((!option.pickupOnly && !option.deliveryOnly && !option.dineinOnly) ||
        (option.pickupOnly && orderPickup) ||
        (option.deliveryOnly && !orderPickup && !dineIn) ||
        (option.dineinOnly && dineIn)) &&
      (!dineIn || (dineIn && option.showInDinein)) &&
      (!option.bridgeDineinTableId || dineIn) &&
      !option.qtyEnabled &&
      (!option.onlinePaymentOnly ||
        !isOfflinePaymentMethod(selectedPaymentMethodID)) &&
      (!option.disabledOnPreorder || !preorderActive)
    "
    style="max-width: 700px; text-align: center; border: 0px"
  >
    <ion-item-divider
      mode="ios"
      lines="none"
      class="mainFontSize"
      [color]="option.notValid ? 'danger' : ''"
      *ngIf="option.title"
    >
      <ion-label class="ion-text-wrap">
        <strong
          *ngIf="
            option.title &&
            (!option.translations ||
              (option.translations && !option.translations.title) ||
              (option.translations &&
                option.translations.title &&
                !option.translations.title[selectedLang]))
          "
          >{{ option.title }}</strong
        >
        <strong
          *ngIf="
            option.translations &&
            option.translations.title &&
            option.translations.title[selectedLang]
          "
        >
          {{ option.translations.title[selectedLang] }}</strong
        >
      </ion-label>
    </ion-item-divider>

    <div
      class="cco-body"
      [class.cco-image-inline]="
        option.imagePosition === 'start' && option.image && option.image.fileName
      "
    >
    <ion-grid
      class="cco-image"
      *ngIf="option && option.image && option.image.fileName"
    >
      <img
        style="width: 100%"
        [src]="
          'https://images.deliverymanager.gr/' +
          store_info.store_id +
          '/cart-custom-options/' +
          option.image.fileName
        "
      />
    </ion-grid>

    <div class="cco-content">
    <ion-item
      lines="none"
      class="minHeightDescriptionItem"
      style="padding-top: 0; margin-top: 0; padding-bottom: 0; margin-bottom: 0"
      *ngIf="option.description"
    >
      <ion-label>
        <p
          *ngIf="
            option.description &&
            (!option.translations ||
              (option.translations && !option.translations.description) ||
              (option.translations &&
                option.translations.description &&
                !option.translations.description[selectedLang]))
          "
        >
          {{ option.description }}
        </p>
        <p
          *ngIf="
            option.translations &&
            option.translations.description &&
            option.translations.description[selectedLang]
          "
        >
          {{ option.translations.description[selectedLang] }}
        </p>
      </ion-label>
    </ion-item>

    <ion-list class="ion-no-padding ion-no-margin">
      <app-radio-type-choices
        *ngIf="
          option.type === 'radio' &&
          !option.showAsPopup &&
          option.choices.length > 0
        "
        [option_timestamp]="option.timestamp"
        [selectedLang]="selectedLang"
      ></app-radio-type-choices>

      <app-select-type-choices
        *ngIf="
          option.type === 'radio' &&
          option.showAsPopup &&
          option.choices.length > 0
        "
        [option_timestamp]="option.timestamp"
        [selectedLang]="selectedLang"
      ></app-select-type-choices>

      <app-checkbox-type-choices
        [option_timestamp]="option.timestamp"
        [selectedLang]="selectedLang"
        *ngIf="option.type === 'checkbox'"
      ></app-checkbox-type-choices>
      <app-text-type-choices
        [option_timestamp]="option.timestamp"
        [selectedLang]="selectedLang"
        *ngIf="option.type === 'text' && !option.showAsPopup"
      ></app-text-type-choices>

      <app-text-popup-type-choices
        [option_timestamp]="option.timestamp"
        [selectedLang]="selectedLang"
        *ngIf="option.type === 'text' && option.showAsPopup"
      ></app-text-popup-type-choices>
    </ion-list>
    </div>
    </div>
  </div>
</span>
